import { z } from 'zod';
import {
  CERTIPY_ACTIONS,
  CERTIPY_INVALID_ACTION_MESSAGE,
  TERRA_ENGINE_OPERATOR_COMMANDS,
  TERRA_ENGINE_UNSUPPORTED_COMMAND_MESSAGE,
  UNLINK_AGENT_MISSING_PEER_ID_MESSAGE,
  isTerraEngineUnsupportedRemoteExecutionCommand,
  type AllowedRemoteExecutionCommand,
} from './internal-network-c2.constants';

export const CertipyActionSchema = z.enum(CERTIPY_ACTIONS);

export const CertipyCommandParamsSchema = z.object({
  action: CertipyActionSchema,
});

export const UnlinkAgentCommandParamsSchema = z.object({
  peer_id: z.string().min(1),
});

export const TerraEngineOperatorCommandSchema = z.enum(
  TERRA_ENGINE_OPERATOR_COMMANDS,
);

export const validateRemoteExecutionCommandParams = ({
  command,
  params,
}: {
  command: AllowedRemoteExecutionCommand;
  params?: Record<string, unknown>;
}): { ok: true } | { ok: false; reason: string } => {
  if (command === 'certipy') {
    const parsed = CertipyCommandParamsSchema.safeParse(params ?? {});

    if (!parsed.success) {
      return { ok: false, reason: CERTIPY_INVALID_ACTION_MESSAGE };
    }
  }

  if (command === 'unlink_agent') {
    const parsed = UnlinkAgentCommandParamsSchema.safeParse(params ?? {});

    if (!parsed.success) {
      return { ok: false, reason: UNLINK_AGENT_MISSING_PEER_ID_MESSAGE };
    }
  }

  return { ok: true };
};

export const skipRemoteExecutionCommand = ({
  command,
  params,
}: {
  command: string;
  params?: Record<string, unknown>;
}): { skip: true; reason: string } | { skip: false } => {
  if (isTerraEngineUnsupportedRemoteExecutionCommand(command)) {
    return { skip: true, reason: TERRA_ENGINE_UNSUPPORTED_COMMAND_MESSAGE };
  }

  if (command === 'certipy' || command === 'unlink_agent') {
    const validation = validateRemoteExecutionCommandParams({
      command,
      params,
    });

    if (!validation.ok) {
      return { skip: true, reason: validation.reason };
    }
  }

  return { skip: false };
};
